import type {
    FormGroup,
    TemplateFormMetadata,
    TemplateFormPropertiesUpdate,
} from '@common/types/templateForms';
import { resolveFormGroups } from '@common/utils/formGroups';
import type { IntakeDesignData } from './types';

interface Options {
    intakeDesign: IntakeDesignData;
    isIntakeFormV2: boolean;
    /** Defaults to the form's metadata */
    metadata?: TemplateFormMetadata | null;
    /** Defaults to the form's groups, including any that only exist on its questions */
    formGroups?: FormGroup[];
}

/**
 * Builds the payload for saving an intake form's own properties from the builder. Questions are
 * saved as they're changed, so they aren't included. Group and question actions send this too,
 * so edits to the form's settings aren't lost if the admin leaves without clicking Next. Pass a
 * value when it has changed but isn't in `intakeDesign` yet. Form groups are only sent for V2
 * forms, since V1 groups are fixed.
 */
export function buildIntakeFormPropertiesPayload({
    intakeDesign,
    isIntakeFormV2,
    metadata = intakeDesign.metadata,
    formGroups = resolveFormGroups(intakeDesign.formGroups, intakeDesign.templateFormFields),
}: Options): TemplateFormPropertiesUpdate {
    return {
        headerDescription: intakeDesign.intakeFormDescription,
        footerTemplate: intakeDesign.textAfterSubmitIntakeForClient,
        metadata,
        ...(isIntakeFormV2 && { formGroups }),
    };
}
